import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GasDividerComponent } from './gas-divider.component';

const COMPONENTS = [
  GasDividerComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasDividerModule { }
